<template>
  <div id="deposit" ref="bank" class="modal fade black-modal" role="dialog" data-backdrop="true" data-keyboard="false">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="sticky-top container-fluid" data-padding-right="" data-margin-right="" style="">
          <div class="align-items-center justify-content-center py-0 modalTopClose row">
            <div class="col-2">
              <button data-dismiss="modal" class="button-close mt-1">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left"
                  class="svg-inline--fa fa-arrow-left p-0 text-white" role="img" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512" style="font-size: 20px;">
                  <path fill="currentColor"
                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z">
                  </path>
                </svg>
              </button>
            </div>
            <div class="d-flex justify-content-center col-8">
              <a data-animatable="fadeInUp" data-delay="500" href="/">
                <div class="logo-title pt-1 img-fluid my-2">
                  <img alt="ZEAGAME แทงบอลออนไลน์ คาสิโนออนไลน์" loading="eager" width="190" height="48" decoding="async"
                    data-nimg="1" class="animated fadeInUp img-fluid" src="/static/img/logo/logo.png"
                    style="color: transparent;" />
                </div>
              </a>
            </div>
            <div class="text-right col-2">
              <button data-dismiss="modal" class="button-close">
                <img src="/static/img/landing/closeIcon.png" width="40" height="40" alt="ปิด" class="" />
              </button>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <div class="container">
            <h5>ฝาก</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="py-4 container">
            <div class="row">
              <div class="col-12 mx-auto mb-2">
                <div class="wallet3">
                  <div class="boxwallet boxout">
                    <UpdateBonus></UpdateBonus>
                  </div>
                </div>
              </div>
            </div>

            <div v-for="(item, index) in ChBankAll" :key="`ch-${index}`" id="deposit-panel" class="text-center mb-3 register-body-form row">
              <div class="pb-3 col-12">
                <div class="footer-account mx-0 py-2 row">
                  <div class="col-3 px-0">

                    <img :style="{
                            'background-color': getBankColorwithCode(
                              item.BankCode
                            ),
                            padding:
                              item.BankCode == 'co.th.truemoney.wallet'
                                ? ''
                                : '10px',
                          }" v-bind:src="getBankImgwithCode(item.BankCode)" />

                    
                    
                    </div>
                  <div class="col-9 text-left">
                    <h4>{{ getBankName(item.BankCode) }}</h4>
                    <h6 style="color: rgb(0, 219, 255);">ชื่อบัญชี : {{ item.fullName }}</h6>
                    <h6 style="color: rgb(249, 237, 51);">เลขที่บัญชี : {{ item.BankAccount }}</h6>
                  </div>
                  <div class="px-0 my-0 col-12">
                    <div class="btn-copy-bank" @click="copyBack(item.BankAccount)"> <img src="/static/img/landing/copyIcon.png" width="21" height="21" class="">
                      คัดลอกบัญชีธนาคาร</div>
                  </div>
                </div>
              </div>
              <div class="px-0 col-12" style="margin-top: -10px;"></div>
            </div>


             
            <div class="modalspanbox mt-3">
              หากลูกค้าฝากเงินสด ผ่านตู้ หรือ ช่องทางอื่น กรุณาติดต่อแอดมินทุกกรณี

              <div>
                <label>หากฝากเงินแล้วยังไม่เข้าภายใน 5 นาที
                  กรุณาอัพสลิปที่ปุ่มด้านล่างนี้</label>
              </div>
              <div class="input-holder mb-3">
              <input style="visibility: initial;"     class=" form-control "
 type="file" @change="previewFiles" id="" />
            </div>
            </div>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { fetchBank } from "@/services/modules/deposit.js";
import moment from "moment";
import DepositFormAuto from "@/components/form/DepositFormAuto";
import DepositFormTrue from "@/components/form/DepositFormTrue";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";
import UpdateBonus from "@/components/form/UpdateBonus";
import api from "@/services/index.js";
import QrScanner from "qr-scanner";
QrScanner.WORKER_PATH = "/static/js/qr/qr-scanner-worker.min.js";

export default {
  name: "DepositForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      // deposit
      ChAuto: [],
      ChBankTrue: [],
      ChBankAll: [],
    };
  },
  components: {
    DepositFormAuto,
    DepositFormTrue,
    UpdateBonus,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    getDate: function (data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },
    async copyBack(item) {
      this.$copyText(item, this.$refs.bank);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },
    async fetchBank() {
      await fetchBank((res) => {
        if (res.status) {
          this.ChBankTrue = res.data.ChBankTrue;
          this.ChAuto = res.data.ChAuto;
          this.ChBankAll = res.data.All;
        } else {
        }
      });
    },
    async previewFiles(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return this.$swal.fire("no files", "", "error");
      const hasName = true;
      if (hasName && files.length) {

        QrScanner.scanImage(files[0])
          .then((result) => this.PullSlip(result))
          .catch((e) => this.$swal.fire((e.message) ? e.message : e, '', "error")).catch(() => { })
          .finally(() => {

          });
      } else this.$swal.fire("no files", "", "error");
    },
    async PullSlip(result) {
      await api
        .post("/user-profile-composite/v1/topup-api/pullslip", {
          barcode: result,
        })
        .then((v) => {
          if (v.success == true) {
            this.$swal.fire("แจ้งเตือน", v.message, "success");
          } else {
            this.$swal.fire("แจ้งเตือน", v.message, "error");
          }
        })
        .catch((e) => {
          this.$swal.fire("แจ้งเตือน", v.message, "error");
        })
        .finally(() => {

        });
    },
  },
  async mounted() {
    await this.fetchBank();
    $(".overlaymodal").on("click", function () {
      $("#depositct").modal("hide");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/DepositForm.vue